// Request-independent settings Rails renders into <meta name="sf-config">, kept out of the Inertia props
// so they don't feed the SSR cache key (see InertiaHelper#inertia_config_tag).

export interface InertiaConfig {
  feedbackUrl: string
  privacyManagerId: string
  careerEventsVisible: boolean
}

const FALLBACK: InertiaConfig = {
  feedbackUrl: '',
  privacyManagerId: 'true',
  careerEventsVisible: true,
}

export function readInertiaConfig(): InertiaConfig {
  if (typeof document === 'undefined') return FALLBACK

  const content = document.querySelector('meta[name="sf-config"]')?.getAttribute('content')
  if (!content) return FALLBACK

  try {
    const parsed = JSON.parse(content) as Partial<InertiaConfig>
    return { ...FALLBACK, ...parsed }
  } catch {
    return FALLBACK
  }
}
